import { useState, useEffect } from "react";

// ui
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import SouthIcon from "@mui/icons-material/South";
import { LeaveGuard } from "./list/LeaveGuard";

// InterFace
import { EditDataDifine } from "../config/dataInterface";
import { LIST_POST } from "../config/const";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";
// ★cmd-po_1140: PoModalShell + PoForm へ乗せ替え
import { PoModalShell } from "./common/PoModalShell";
// ★cmd-po_1221 R9: 編集成功をトースト→結果モーダルへ統一
import { DataAddModalResult } from "./DataAddModalResult";
import { PoButton } from "./common/PoButton";
import { PoField, PoLabel, PoTextField, PoSelect, PoCheckbox, PoCheckGroup, PoCheckRow, PoHelper, PoFileDrop, poAutocompleteSx } from "./common/PoForm";

interface DataEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  editData: EditDataDifine | null;
  setEditData: (data: EditDataDifine | null) => void;
  putEditData: () => void;
  groupList: {
    group_id: number;
    group_name: string;
  }[];
  categoryList: { id: number; category_name: string }[];
  accountCollaborateCompanySaleList: {
    sale_company_id: number;
    sale_company_name: string;
    id: number;
    account_name: string;
  }[];
  selectServiseInfo: {
    service_plan_data: { service_name: string }[];
    service_content_data: { service_name: string }[];
    service_campaign_pulldown_data: { service_name: string }[];
    service_campaign_checkbox_data: { service_name: string }[];
  };
  selectTossUpInfo: {
    tossUpCategoryNameList: {
      category_id: number;
      category_name: string;
    }[];
    tossUpProductNameList: {
      category_id: number;
      category_name: string;
      product_name: string;
    }[];
  };
  /** 編集用の選択肢リスト（editType==="list" で渡した場合、このリストで表示・選択） */
  optionListForEdit?: { id: number; name: string }[];
}

export function DataEditModal(props: DataEditModalProps) {
  const {
    onModal,
    swCloseModal,
    editData,
    setEditData,
    putEditData,
    groupList,
    categoryList,
    accountCollaborateCompanySaleList,
    selectServiseInfo,
    selectTossUpInfo,
    optionListForEdit,
  } = props;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const [leaveGuardOpen, setLeaveGuardOpen] = useState(false);
  const hasUnsavedChanges = () => {
    if (!editData) return false;
    if (
      editData.editType === "customer_picture" ||
      editData.editType === "outside_site_logo" ||
      editData.editType === "outside_site_favicon" ||
      editData.editType === "site_pdf_path"
    ) {
      return editData.customer_picture !== null;
    }
    return JSON.stringify(editData.editValue) !== JSON.stringify(editData.value);
  };
  const handleCancel = () => {
    if (hasUnsavedChanges()) {
      setLeaveGuardOpen(true);
    } else {
      swCloseModal();
    }
  };
  const [autocompleteInputList, setAutocompleteInputList] = useState<string[]>(
    [],
  );
  const [autocompleteInput, setAutocompleteInput] = useState<string>("");
  useEffect(() => {
    let autocompleteInputList: string[] = [];
    if (editData && editData.editType === "list") {
      if (editData.key === "category_name") {
        autocompleteInputList = categoryList.map((input) => {
          return input.category_name;
        });
      } else if (editData.key === "sale_company_group_id") {
        autocompleteInputList = groupList.map((input) => {
          return input.group_name;
        });
      } else if (editData.key === "authority") {
        autocompleteInputList = LIST_POST["edit_authority"].map((input) => {
          return input.value;
        });
      } else if (
        editData.key === "sale_account_name" ||
        editData.key === "toss_up_account_name" ||
        editData.key === "closer_account_name"
      ) {
        autocompleteInputList = accountCollaborateCompanySaleList.map(
          (input) => {
            return input.sale_company_name + " / " + input.account_name;
          },
        );
      } else if (optionListForEdit && optionListForEdit.length > 0) {
        autocompleteInputList = optionListForEdit.map((input) => input.name);
        const found = optionListForEdit.find(
          (o) => String(o.id) === String(editData.editValue)
        );
        if (found) setAutocompleteInput(found.name);
        else setAutocompleteInput("");
      } else {
        autocompleteInputList = LIST_POST[editData.key].map((input) => {
          return input.value;
        });
      }
    } else {
      setAutocompleteInput("");
    }
    setAutocompleteInputList(autocompleteInputList);
  }, [editData, optionListForEdit]);

  useEffect(() => {
    if (editData) {
      let editValue = editData.editValue;
      if (editData.editValue !== undefined && editData.editValue !== null) {
        if (editData.key === "category_name") {
          categoryList.map((input) => {
            if (autocompleteInput === input.category_name) {
              editValue = String(input.id);
            }
          });
        } else if (editData.key === "sale_company_group_id") {
          groupList.map((input) => {
            if (autocompleteInput === input.group_name) {
              editValue = String(input.group_id);
            }
          });
        } else if (editData.key === "authority") {
          LIST_POST["edit_authority"].map((input) => {
            if (autocompleteInput === input.value) {
              editValue = String(input.id);
            }
          });
        } else if (
          editData.key === "sale_account_name" ||
          editData.key === "toss_up_account_name" ||
          editData.key === "closer_account_name"
        ) {
          accountCollaborateCompanySaleList.map((input) => {
            if (
              autocompleteInput ===
              input.sale_company_name + " / " + input.account_name
            ) {
              editValue = String(input.id);
            }
          });
        } else if (optionListForEdit && optionListForEdit.length > 0) {
          optionListForEdit.forEach((input) => {
            if (input.name === autocompleteInput) {
              editValue = String(input.id);
            }
          });
        } else {
          LIST_POST[editData.key].map((input) => {
            if (autocompleteInput === input.value) {
              editValue = String(input.id);
            }
          });
        }
        setEditData({
          ...editData,
          editValue: editValue,
        });
      } else {
        setEditData({
          ...editData,
          editValue: "",
        });
      }
    }
  }, [autocompleteInput]);

  // ★cmd-po_1221 R9: 成功トースト+自動クローズ処理を廃止。
  // 成功時は shell が隠れ（open条件 status!=="success"）DataAddModalResult(sibling)が開く＝閉じるで手動クローズ。

  return editData ? (
    <>
    {/* ★cmd-po_1140: PoModalShell へ乗せ替え（w560・edit-flow） */}
    <PoModalShell
      open={onModal && editData?.status !== "success"}
      title={`編集 - ${editData.name}`}
      onClose={handleCancel}
      width="w560"
      testidPrefix="data-edit"
      modalTestId="data-edit-modal"
      frameTestId="data-edit-modal-frame"
      footer={
        editData.status === "before" ? (
          <>
            <PoButton
              variant="secondary"
              data-testid="edit-modal-cancel-button"
              onClick={handleCancel}
            >
              キャンセル
            </PoButton>
            <PoButton
              variant="primary"
              data-testid="edit-modal-save-button"
              disabled={
                (editData.editType === "customer_picture" ||
                  editData.editType === "outside_site_logo" ||
                  editData.editType === "outside_site_favicon" ||
                  editData.editType === "site_pdf_path")
                  ? editData.customer_picture === null
                  : editData.value === editData.editValue
              }
              onClick={putEditData}
            >
              編集<EditNoteIcon sx={{ marginLeft: "6px" }} />
            </PoButton>
          </>
        ) : editData.status !== "success" ? (
          <PoButton
            variant="primary"
            onClick={() => setEditData({ ...editData, status: "before" as const })}
          >
            OK
          </PoButton>
        ) : undefined
      }
    >
      <LeaveGuard
        open={leaveGuardOpen}
        fieldName={editData.name}
        onClose={() => { setLeaveGuardOpen(false); swCloseModal(); }}
        onReturn={() => setLeaveGuardOpen(false)}
      />
      {/* ★ body — Typography 廃止、PoModalShell body に統合 */}
          {editData.status === "before" ? (
            <>
              {editData.editType === "entry_info" ? (
                <Box
                  key="shozai1"
                >
                  <PoLabel>プラン</PoLabel>
                  <Box key="servicePlanBox">
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Select
                        labelId="serch-input-label"
                        id="serch-input-option"
                        key={"servicePlanSelect"}
                        value={
                          (editData.editValue as { [key: string]: string })
                            .servicePlanName
                        }
                        onChange={(e) => {
                          const servicePlanName = e.target.value as string;
                          let editValue = editData.editValue as {
                            [key: string]: string | string[];
                          };
                          editValue["servicePlanName"] = servicePlanName;
                          setEditData({
                            ...editData,
                            editValue,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {selectServiseInfo.service_plan_data.map(
                          (service, plan_i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + plan_i}
                                value={service.service_name}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    service.service_name === ""
                                      ? "14px"
                                      : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {service.service_name}
                              </MenuItem>
                            );
                          },
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                  {selectServiseInfo.service_content_data.length > 0 ? (
                    <Box key="contractServiceContent">
                      <PoLabel>コンテンツ</PoLabel>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: "10px",
                          marginBottom: "20px",
                          marginLeft: "5px",
                          width: "calc(100% - 10px)",
                        }}
                      >
                        {selectServiseInfo.service_content_data.map(
                          (service) => {
                            return (
                              <Box
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceContentNameList.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let serviceContentNameList = (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceContentNameList.concat();

                                    if (
                                      (
                                        editData.editValue as {
                                          [key: string]: string[];
                                        }
                                      ).serviceContentNameList.findIndex(
                                        (serviceName) =>
                                          serviceName === service.service_name,
                                      ) > -1
                                    ) {
                                      serviceContentNameList =
                                        serviceContentNameList.filter(
                                          (serviceName) =>
                                            serviceName !==
                                            service.service_name,
                                        );
                                    } else {
                                      serviceContentNameList.push(
                                        service.service_name,
                                      );
                                    }
                                    let editValue = editData.editValue as {
                                      [key: string]: string | string[];
                                    };
                                    editValue["serviceContentNameList"] =
                                      serviceContentNameList;
                                    setEditData({
                                      ...editData,
                                      editValue,
                                    });
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-5px",
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          },
                        )}
                      </Box>
                    </Box>
                  ) : null}
                  {selectServiseInfo.service_campaign_pulldown_data.length >
                  0 ? (
                    <Box key="serviceeCampaignPulldownLabelBox">
                      <PoLabel>
                        {selectServiseInfo.service_campaign_checkbox_data
                          .length > 0
                          ? "キャンペーン1"
                          : "キャンペーン"}
                      </PoLabel>
                      <Box key="serviceeCampaignPulldownBox">
                        <FormControl
                          fullWidth
                          sx={{
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "5px",
                            width: "calc(100% - 10px)",
                          }}
                        >
                          <Select
                            labelId="serch-input-label"
                            id="serch-input-option"
                            key={"serviceCampaignPulldownSelect"}
                            value={
                              (editData.editValue as { [key: string]: string })
                                .serviceCampaignPulldownName
                            }
                            onChange={(e) => {
                              const serviceCampaignPulldownName = e.target
                                .value as string;
                              let editValue = editData.editValue as {
                                [key: string]: string | string[];
                              };
                              editValue["serviceCampaignPulldownName"] =
                                serviceCampaignPulldownName;
                              setEditData({
                                ...editData,
                                editValue,
                              });
                            }}
                            sx={{
                              height: "30px",
                              textAlign: "end",
                              fontSize: "14px",
                            }}
                          >
                            {selectServiseInfo.service_campaign_pulldown_data.map(
                              (service, plan_i) => {
                                return (
                                  <MenuItem
                                    key={
                                      "tableColumnKomokuCampaignPulldown" +
                                      plan_i
                                    }
                                    value={service.service_name}
                                    sx={{
                                      fontSize: "14px",
                                      height:
                                        service.service_name === ""
                                          ? "14px"
                                          : "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {service.service_name}
                                  </MenuItem>
                                );
                              },
                            )}
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  ) : null}
                  {selectServiseInfo.service_campaign_checkbox_data.length >
                  0 ? (
                    <Box key="contractServiceContent">
                      <PoLabel>
                        {selectServiseInfo.service_campaign_pulldown_data
                          .length > 0
                          ? "キャンペーン2"
                          : "キャンペーン"}
                      </PoLabel>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: "10px",
                          marginBottom: "20px",
                          marginLeft: "5px",
                          width: "calc(100% - 10px)",
                        }}
                      >
                        {selectServiseInfo.service_campaign_checkbox_data.map(
                          (service) => {
                            return (
                              <Box
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceCampaignCheckboxName.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let serviceCampaignCheckboxName = (
                                      editData.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).serviceCampaignCheckboxName.concat();

                                    if (
                                      (
                                        editData.editValue as {
                                          [key: string]: string[];
                                        }
                                      ).serviceCampaignCheckboxName.findIndex(
                                        (serviceName) =>
                                          serviceName === service.service_name,
                                      ) > -1
                                    ) {
                                      serviceCampaignCheckboxName =
                                        serviceCampaignCheckboxName.filter(
                                          (serviceName) =>
                                            serviceName !==
                                            service.service_name,
                                        );
                                    } else {
                                      serviceCampaignCheckboxName.push(
                                        service.service_name,
                                      );
                                    }
                                    let editValue = editData.editValue as {
                                      [key: string]: string | string[];
                                    };
                                    editValue["serviceCampaignCheckboxName"] =
                                      serviceCampaignCheckboxName;
                                    setEditData({
                                      ...editData,
                                      editValue,
                                    });
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-5px",
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          },
                        )}
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              ) : editData.editType === "toss_up_info" ? (
                <Box
                  key="shozai1"
                >
                  <Box key="shozaiClick">
                    {selectTossUpInfo.tossUpCategoryNameList.map(
                      (categoryName, category_i) => {
                        function categoryDisabled(category_id: number) {
                          let categoryDisabled = false;
                          selectTossUpInfo.tossUpProductNameList.map(
                            (productName) => {
                              if (
                                (
                                  editData?.editValue as {
                                    [key: string]: string[];
                                  }
                                ).product_name_list.includes(
                                  productName.product_name,
                                ) &&
                                category_id === productName.category_id
                              ) {
                                categoryDisabled = true;
                              }
                            },
                          );
                          return categoryDisabled;
                        }
                        return (
                          <>
                            <Box
                              key={"category_name_" + category_i}
                              sx={{ marginRight: "25px", marginTop: "15px" }}
                            >
                              <Checkbox
                                checked={(
                                  editData?.editValue as {
                                    [key: string]: string[];
                                  }
                                ).category_id_list.includes(
                                  String(categoryName.category_id),
                                )}
                                disabled={
                                  categoryDisabled(categoryName.category_id)
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  let _category_id_list = (
                                    editData?.editValue as {
                                      [key: string]: string[];
                                    }
                                  ).category_id_list.concat();
                                  let _product_name_list = (
                                    editData?.editValue as {
                                      [key: string]: string[];
                                    }
                                  ).product_name_list.concat();
                                  if (
                                    (
                                      editData?.editValue as {
                                        [key: string]: string[];
                                      }
                                    ).category_id_list.includes(
                                      String(categoryName.category_id),
                                    )
                                  ) {
                                    _category_id_list =
                                      _category_id_list.filter(
                                        (category_id) =>
                                          category_id !==
                                          String(categoryName.category_id),
                                      );
                                  } else {
                                    _category_id_list.push(
                                      String(categoryName.category_id),
                                    );
                                    selectTossUpInfo.tossUpProductNameList.map(
                                      (tossUpProduct) => {
                                        if (
                                          tossUpProduct.category_id ===
                                          categoryName.category_id
                                        ) {
                                          _product_name_list.push(
                                            tossUpProduct.product_name,
                                          );
                                        }
                                      },
                                    );
                                  }
                                  let editValue = editData.editValue as {
                                    [key: string]: string | string[];
                                  };
                                  editValue["category_id_list"] =
                                    _category_id_list;
                                  editValue["product_name_list"] =
                                    _product_name_list;
                                  setEditData({
                                    ...editData,
                                    editValue,
                                  });
                                }}
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 16 },
                                  marginTop: "-2px",
                                }}
                              />
                              {categoryName.category_name}
                            </Box>
                            {selectTossUpInfo.tossUpProductNameList.map(
                              (productName, product_i) => {
                                if (
                                  categoryName.category_name ===
                                  productName.category_name
                                ) {
                                  return (
                                    <Box
                                      key={
                                        "category_product_name_" +
                                        category_i +
                                        "_" +
                                        product_i
                                      }
                                      sx={{ marginRight: "25px" }}
                                    >
                                      <Checkbox
                                        checked={(
                                          editData?.editValue as {
                                            [key: string]: string[];
                                          }
                                        ).product_name_list.includes(
                                          productName.product_name,
                                        )}
                                        onClick={() => {
                                          let _category_id_list = (
                                            editData?.editValue as {
                                              [key: string]: string[];
                                            }
                                          ).category_id_list.concat();
                                          let _product_name_list = (
                                            editData?.editValue as {
                                              [key: string]: string[];
                                            }
                                          ).product_name_list.concat();
                                          if (
                                            (
                                              editData?.editValue as {
                                                [key: string]: string[];
                                              }
                                            ).product_name_list.includes(
                                              productName.product_name,
                                            )
                                          ) {
                                            _product_name_list =
                                              _product_name_list.filter(
                                                (product_name) =>
                                                  product_name !==
                                                  productName.product_name,
                                              );
                                          } else {
                                            _product_name_list.push(
                                              productName.product_name,
                                            );
                                            if (
                                              !(
                                                editData?.editValue as {
                                                  [key: string]: string[];
                                                }
                                              ).category_id_list.includes(
                                                String(
                                                  categoryName.category_id,
                                                ),
                                              )
                                            ) {
                                              _category_id_list.push(
                                                String(
                                                  categoryName.category_id,
                                                ),
                                              );
                                            }
                                          }
                                          let editValue =
                                            editData.editValue as {
                                              [key: string]: string | string[];
                                            };
                                          editValue["category_id_list"] =
                                            _category_id_list;
                                          editValue["product_name_list"] =
                                            _product_name_list;
                                          setEditData({
                                            ...editData,
                                            editValue,
                                          });
                                        }}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 16,
                                          },
                                          marginTop: "-2px",
                                          marginLeft: "20px",
                                        }}
                                      />
                                      {productName.product_name}
                                    </Box>
                                  );
                                }
                              },
                            )}
                          </>
                        );
                      },
                    )}
                  </Box>
                </Box>
              ) : (
                <>
                  {/* ★変更前フィールド — testId=edit-modal-field-before */}
                  <PoField fieldKey="before" testId="edit-modal-field-before">
                    <PoTextField
                      disabled
                      fullWidth
                      value={
                        (editData.editType === "list" ||
                          editData.editType === "text" ||
                          editData.editType === "multitext" ||
                          editData.editType === "column_text" ||
                          editData.editType === "column_select_one" ||
                          editData.editType === "column_select_multiple" ||
                          editData.editType === "column_date") &&
                        (typeof editData.value === "string" ||
                          typeof editData.value === "number")
                          ? editData.value
                          : (editData.editType === "outside_site_logo" ||
                                editData.editType === "outside_site_favicon" ||
                                editData.editType === "site_pdf_path") &&
                              (typeof editData.value === "string" ||
                                typeof editData.value === "number")
                            ? editData.value.split("/").pop()
                            : (editData.editType === "customer_text" ||
                                  editData.editType === "customer_multitext" ||
                                  editData.editType === "customer_select_one" ||
                                  editData.editType === "customer_date") &&
                                typeof editData.value !== "string"
                              ? editData.value[editData.key]
                              : editData.editType === "customer_picture" &&
                                  typeof editData.value !== "string" &&
                                  (editData.value[editData.key] as string)
                                ? (editData.value[editData.key] as string)
                                    .split("/")
                                    .pop()
                                : editData.editType ===
                                      "customer_select_multiple" &&
                                    typeof editData.key === "string" &&
                                    ((
                                      editData.value as {
                                        [key: string]: string | string[];
                                      }
                                    )[editData.key] as string[])
                                  ? (
                                      (
                                        editData.value as {
                                          [key: string]: string | string[];
                                        }
                                      )[editData.key] as string[]
                                    ).join("、")
                                  : ""
                      }
                      multiline={
                        editData.editType === "multitext" ||
                        editData.editType === "customer_multitext"
                      }
                      rows={
                        editData.editType === "multitext" ||
                        editData.editType === "customer_multitext"
                          ? 4
                          : undefined
                      }
                    />
                  </PoField>
                  <Box sx={{ textAlign: "center" }}>↓</Box>
                  {/* ★変更後フィールド — testId=edit-modal-field-${editData.key} */}
                  <PoField fieldKey={editData.key} testId={`edit-modal-field-${editData.key}`}>
                  {editData.editType === "text" ||
                  editData.editType === "multitext" ||
                  editData.editType === "column_text" ||
                  editData.editType === "column_date" ? (
                    <PoTextField
                      type={
                        editData.editType === "column_date" ? "date" : "text"
                      }
                      value={editData.editValue}
                      fullWidth
                      onChange={(e) => {
                        setEditData({
                          ...editData,
                          editValue: e.target.value,
                        });
                      }}
                      multiline={editData.editType === "multitext"}
                      rows={editData.editType === "multitext" ? 4 : undefined}
                    />
                  ) : editData.editType === "list" ? (
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Autocomplete
                        clearIcon={null}
                        options={autocompleteInputList}
                        value={autocompleteInput}
                        onChange={(event: any, newValue: string | null) => {
                          if (newValue) {
                            setAutocompleteInput(newValue);
                          }
                        }}
                        renderInput={(params) => (
                          <PoTextField
                            value={autocompleteInput}
                            sx={poAutocompleteSx}
                            {...params}
                          />
                        )}
                      />
                      {editData.key === "login_status" ? (
                        <PoHelper>
                          ※一度「ログイン不可能」としたアカウントを「正常」に変更することはできません
                        </PoHelper>
                      ) : null}
                      {editData.key === "sns_type" ? (
                        <PoHelper>
                          ※変更後、必要に応じてチャットアプリ連携情報を変更してください
                        </PoHelper>
                      ) : null}
                      {(editData.key === "sale_account_name" ||
                        editData.key === "toss_up_account_name") &&
                      (loginUser?.authority === "パートナー" ||
                        loginUser?.authority === "営業アカウント") ? (
                        <PoHelper>
                          ※変更後、閲覧権限によっては一覧から消去される点をご留意ください。
                        </PoHelper>
                      ) : null}
                    </FormControl>
                  ) : editData.editType === "customer_text" ||
                    editData.editType === "customer_multitext" ? (
                    <PoTextField
                      value={
                        typeof editData.editValue === "string" ||
                        Array.isArray(editData.editValue)
                          ? ""
                          : editData.editValue[editData.key]
                      }
                      fullWidth
                      onChange={(e) => {
                        if (
                          editData.half_width_number_flg === 1 &&
                          !/^\d*$/.test(e.target.value)
                        ) {
                          return;
                        }
                        const editValue = editData.editValue as {
                          [key: string]: string | string[];
                        };
                        let customer_info = { ...editValue };
                        customer_info[editData.key] = e.target.value;
                        if (editData.tel_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editPhoneNumber: e.target.value,
                          });
                        } else if (editData.name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editName: e.target.value,
                          });
                        } else if (editData.company_name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editCustomerName: e.target.value,
                          });
                        } else {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                          });
                        }
                      }}
                      multiline={editData.editType === "customer_multitext"}
                      rows={
                        editData.editType === "customer_multitext"
                          ? 4
                          : undefined
                      }
                    />
                  ) : editData.editType === "customer_select_one" ? (
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Select
                        label=""
                        labelId="serch-input-label"
                        id="serch-input"
                        value={
                          typeof editData.editValue === "string" ||
                          Array.isArray(editData.editValue)
                            ? ""
                            : editData.editValue[editData.key]
                        }
                        onChange={(e) => {
                          const editValue = editData.editValue as {
                            [key: string]: string | string[];
                          };
                          let customer_info = { ...editValue };
                          customer_info[editData.key] = e.target.value;
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {editData.customerList.map((option, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={option.option_select}
                              sx={{
                                fontSize: "14px",
                                height:
                                  option.option_select === "" ? "14px" : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {option.option_select}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  ) : editData.editType === "customer_select_multiple" ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      {editData.customerList.map((option, i) => {
                        return (
                          <Box
                            sx={{ marginRight: "25px" }}
                          >
                            <Checkbox
                              checked={
                                ((
                                  editData.editValue as {
                                    [key: string]: string | string[];
                                  }
                                )[editData.key] as string[])
                                  ? (
                                      (
                                        editData.editValue as {
                                          [key: string]: string | string[];
                                        }
                                      )[editData.key] as string[]
                                    ).findIndex(
                                      (_option_select) =>
                                        _option_select === option.option_select,
                                    ) > -1
                                  : false
                              }
                              onClick={() => {
                                const editValue = editData.editValue as {
                                  [key: string]: string | string[];
                                };
                                let customer_info = { ...editValue };
                                let customer_info_list: string[] = [];
                                if (customer_info[editData.key]) {
                                  customer_info_list = customer_info[
                                    editData.key
                                  ].concat() as string[];
                                }
                                if (
                                  customer_info_list.findIndex(
                                    (_option_select) =>
                                      _option_select === option.option_select,
                                  ) > -1
                                ) {
                                  customer_info_list =
                                    customer_info_list.filter(
                                      (_option_select) =>
                                        _option_select !== option.option_select,
                                    );
                                } else {
                                  customer_info_list.push(option.option_select);
                                }
                                customer_info[editData.key] =
                                  customer_info_list;
                                setEditData({
                                  ...editData,
                                  editValue: customer_info,
                                });
                              }}
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 16 },
                                marginTop: "-5px",
                              }}
                            />
                            {option.option_select}
                          </Box>
                        );
                      })}
                    </Box>
                  ) : editData.editType === "customer_date" ? (
                    <PoTextField
                      type="date"
                      value={
                        typeof editData.editValue === "string" ||
                        Array.isArray(editData.editValue)
                          ? "2000-01-01"
                          : editData.editValue[editData.key]
                      }
                      fullWidth
                      onChange={(e) => {
                        if (
                          editData.half_width_number_flg === 1 &&
                          !/^\d*$/.test(e.target.value)
                        ) {
                          return;
                        }
                        const editValue = editData.editValue as {
                          [key: string]: string | string[];
                        };
                        let customer_info = { ...editValue };
                        customer_info[editData.key] = e.target.value;
                        if (editData.tel_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editPhoneNumber: e.target.value,
                          });
                        } else if (editData.name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editName: e.target.value,
                          });
                        } else if (editData.company_name_flg === 1) {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                            editCustomerName: e.target.value,
                          });
                        } else {
                          setEditData({
                            ...editData,
                            editValue: customer_info,
                          });
                        }
                      }}
                    />
                  ) : editData.editType === "customer_picture" ||
                    editData.editType === "outside_site_logo" ||
                    editData.editType === "outside_site_favicon" ||
                    editData.editType === "site_pdf_path" ? (
                    <PoFileDrop
                      inputProps={{
                        id: "textFieldPicture",
                        onChange: (
                          event_file: React.ChangeEvent<HTMLInputElement>,
                        ) => {
                          if (
                            event_file.target.files &&
                            event_file.target.files.length > 0
                          ) {
                            const file = event_file.target.files[0];
                            setEditData({
                              ...editData,
                              customer_picture: file,
                            });
                          }
                        },
                      }}
                      onClear={() => setEditData({ ...editData, customer_picture: null })}
                    />
                  ) : editData.editType === "column_select_one" ? (
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Select
                        label=""
                        labelId="serch-input-label"
                        id="serch-input"
                        value={editData.editValue}
                        onChange={(e) => {
                          setEditData({
                            ...editData,
                            editValue: e.target.value,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {editData.customerList.map((option, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={option.option_select}
                              sx={{
                                fontSize: "14px",
                                height:
                                  option.option_select === "" ? "14px" : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {option.option_select}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  ) : editData.editType === "column_select_multiple" ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      {editData.customerList.map((option, i) => {
                        return (
                          <Box
                            sx={{ marginRight: "25px" }}
                          >
                            <Checkbox
                              checked={
                                Array.isArray(editData.editValue) &&
                                editData.editValue.includes(
                                  option.option_select,
                                )
                              }
                              onClick={() => {
                                let editValue = (
                                  editData.editValue as string[]
                                ).concat();
                                if (
                                  Array.isArray(editData.editValue) &&
                                  editData.editValue.includes(
                                    option.option_select,
                                  )
                                ) {
                                  editValue = editValue.filter(
                                    (option_select) =>
                                      option_select !== option.option_select,
                                  );
                                } else {
                                  editValue.push(option.option_select);
                                }
                                setEditData({
                                  ...editData,
                                  editValue: editValue,
                                });
                              }}
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 16 },
                                marginTop: "-5px",
                              }}
                            />
                            {option.option_select}
                          </Box>
                        );
                      })}
                    </Box>
                  ) : null}
                  </PoField>
                </>
              )}
            {/* ★footer prop に移動済み — 旧フッタ(save/cancel)退役 */}
            </>
          ) : editData.status === "failed" ? (
            <>
              <Box className="info-alert -error" data-testid="edit-modal-status-failed">
                データの登録に失敗しました。
                <br />
                データの形式が異なる可能性があります。
              </Box>
              {/* ★footer prop に移動済み — OK ボタン退役 */}
            </>
          ) : editData.status === "success" ? null : (
            <>
              <Box>{editData.status}</Box>
              {/* ★footer prop に移動済み — OK ボタン退役 */}
            </>
          )}
    </PoModalShell>
    {/* ★cmd-po_1221 R9: 編集成功=結果モーダル（トースト→統一・閉じるで手動クローズ） */}
    <DataAddModalResult
      onModal={onModal && editData?.status === "success"}
      onDataAddModalResult="success"
      successMessage="変更を保存しました。"
      swCloseModal={swCloseModal}
      addModalTitle="編集"
    />
    </>
  ) : null;
}
